import request from '../helpers/request'

export default {
  sendData: async formData => {
    const { data } = await request.post('/save-custom-feedback/', formData)

    return data
  }
}
